const DEFAULT_COUNT = 0;

function parse(number, float) {
  if (float) {
    return parseFloat(number) || 0;
  }

  return parseInt(String(number).replace(/[^0-9-]/g, ''), 10) || 0;
}

export default function greaterThan(value = '', options = {}) {
  if (['', undefined, null].includes(value)) {
    return false;
  }

  const {
    count,
    equal,
    float,
  } = options;

  const max = parse(count || DEFAULT_COUNT, float);
  const number = parse(value, float);

  if ((equal && number >= max) || number > max) {
    return false;
  }

  return true;
}

greaterThan.message = function message(value, options = {}) {
  const {
    count,
    equal,
    formatter,
  } = options;

  const min = count || DEFAULT_COUNT;
  const format = formatter || ((number) => number);
  const prefix = equal ? 'precisa ser maior ou igual a' : 'precisa ser maior que';

  return options.message || `${prefix} "${format(min)}"`;
};
